<section class="relative w-full overflow-hidden bg-neutral-gray-900 h-[640px] md:h-[500px] lg:h-[600px]">
  <!-- Imagen de fondo ampliada -->
   <div class="w-full flex justify-center">
        <!-- Mobile -->
        <img
          src="assets/img/banner-cantera.svg"
          alt="Banner Maestros Cantera"
          class="w-full h-auto object-contain block sm:hidden"
        />

        <!-- Desktop -->
        <img
          src="assets/img/banner-desktop.png"
          alt="Banner Maestros Cantera Desktop"
          class="w-full max-w-[1920px] h-auto object-contain hidden sm:block"
        />
      </div>

  <!-- Gradiente oscuro en la parte inferior -->
  <div class="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" style="background: linear-gradient(to top, rgba(0,0,0,1) 4.375%, rgba(0,0,0,0) 56.771%);"></div>

  <!-- Barra negra superior con efecto de marca de agua -->
  <div class="absolute top-0 left-0 right-0 h-[115px] overflow-hidden pointer-events-none">
    <div class="absolute inset-0 bg-gradient-to-b from-black to-transparent opacity-60"></div>
  </div>

  <!-- Contenido del hero -->
  <div class="absolute inset-0 flex flex-col justify-between pointer-events-none">
    <div class="w-full max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8 flex flex-col justify-between h-full">
      <!-- Textos superiores - Solo visible en mobile -->
       <div class="text-left sm:text-center pt-4">
          <div class="block sm:hidden font-poppins">
            <h1 class="text-white text-[24px] font-bold leading-[1.1] mb-1">
              La comunidad
            </h1>
            <p class="text-white font-normal text-[16px] tracking-[0.08em] uppercase">
              MÁS GRANDE DE
            </p>
          </div>
        </div>

      <!-- Botones inferiores -->
      <div class="flex flex-col gap-3 items-center pointer-events-auto pb-6 md:pb-8 lg:pb-12 md:mt-auto">
        <ui-button
          variant="primary"
          size="x-large"
          [fullWidth]="true"
          class="w-full max-w-[296px] md:max-w-[320px]"
          (clicked)="openRegisterPromptModal()">
          <span class="flex items-center gap-2 justify-center">
            <span>Unirme a Cantera</span>
            <app-svg-icon [iconName]="SvgIcon.ARROW_RIGHT_WHITE" [size]="16"></app-svg-icon>
          </span>
        </ui-button>

        <p class="text-white font-poppins text-sm md:text-base font-normal opacity-90 m-0">
          Tu apoyo para seguir creciendo
        </p>
      </div>
    </div>
  </div>

  <!-- Modales -->
  <app-register-prompt-modal [isOpen]="showRegisterPromptModal"
    (closed)="closeRegisterPromptModal()"></app-register-prompt-modal>

  <app-unicon-register-modal [isOpen]="showUniconRegisterModal"
    (closed)="closeUniconRegisterModal()"></app-unicon-register-modal>

</section>